import { defineStore } from 'pinia'
import Filtros from '@/services/model/filtros'

export const useFiltrosStore = defineStore('Filtros', {
    state() {
        let filtro = (null as null | Filtros);
        return { filtro };
    },
    actions: {
        update(value: Filtros): void {            
            this.filtro = value;
        }
    }
})